var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoConfusion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99976 6.75003H7.99976M3.99976 4.25003H5.99976",
    stroke: "#5A6572",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04916 9.50003C2.39911 9.43608 1.91213 9.24083 1.58554 8.91423C0.999756 8.32848 0.999756 7.38563 0.999756 5.50003V5.25003C0.999756 3.36441 0.999756 2.42161 1.58554 1.83582C2.17133 1.25003 3.11414 1.25003 4.99976 1.25003H6.99976C8.88535 1.25003 9.8282 1.25003 10.414 1.83582C10.9998 2.42161 10.9998 3.36441 10.9998 5.25003V5.50003C10.9998 7.38563 10.9998 8.32848 10.414 8.91423C9.8282 9.50003 8.88535 9.50003 6.99976 9.50003C6.71951 9.50628 6.49631 9.52758 6.27706 9.57753C5.67786 9.71548 5.12301 10.0221 4.57469 10.2895C3.7934 10.6704 3.40276 10.8609 3.1576 10.6826C2.6886 10.3333 3.14703 9.25098 3.24976 8.75003",
    stroke: "#5A6572",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConfusion);
export default __webpack_public_path__ + "static/media/no_confusion.0aa75b3fff86b212ee95ff7a91ca0a90.svg";
export { ForwardRef as ReactComponent };